import script from "./dialogCom.vue?vue&type=script&setup=true&lang=ts"
export * from "./dialogCom.vue?vue&type=script&setup=true&lang=ts"

import "./dialogCom.vue?vue&type=style&index=0&id=a460ab48&scoped=true&lang=less"

import exportComponent from "D:\\code\\GPT\\front-web\\chat-gpt-laset\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a460ab48"]])

export default __exports__